export default "__VITE_ASSET__D_tQpDqw__"